import type { ContentVersion } from "../utils/types"
import { getContentVersion } from "../utils/content"
import { useJourneyStore } from "../stores/journey"

export default async (): Promise<ContentVersion | null> => {
  const journeyStore = useJourneyStore()

  if (journeyStore.journeyData) {
    const contentVersionId = journeyStore.journeyData.group.content_version.id
    return getContentVersion(contentVersionId)
  }

  return null
}
